import { render } from "./Information.vue?vue&type=template&id=381cc490&scoped=true"
const script = {}

import "./Information.vue?vue&type=style&index=0&id=381cc490&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Y\\Desktop\\guo-wei\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381cc490"]])

export default __exports__